import * as React from 'react';
import { Accordion } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { FacetId } from '../../../../../types.js';
import { ConnectedFacetContainerMobile } from '../../../FacetContainerMobile/ConnectedFacetContainerMobile.js';
import { ConnectedFacetInputPriceRangeMobile } from '../../../FacetInputPriceRange/ConnectedFacetInputPriceRangeMobile.js';

const ConnectedFacetsContainer = ({ facets , onChange  })=>{
    const { getLabel  } = useIntl();
    const renderFacet = (facet)=>{
        switch(facet.id){
            case FacetId.price:
                return /*#__PURE__*/ React.createElement(ConnectedFacetInputPriceRangeMobile, {
                    id: facet.id,
                    key: facet.attribute,
                    attribute: facet.attribute,
                    label: getLabel(facet.labelKey || facet.id),
                    onChange: onChange
                });
            default:
                var _label;
                return /*#__PURE__*/ React.createElement(ConnectedFacetContainerMobile, {
                    key: facet.attribute,
                    facet: facet,
                    attribute: facet.attribute,
                    limit: 100,
                    label: (_label = facet.label) !== null && _label !== void 0 ? _label : getLabel(facet.labelKey || facet.id),
                    onChange: onChange
                });
        }
    };
    return /*#__PURE__*/ React.createElement(Accordion, {
        className: "connected-facets-container"
    }, facets.map(renderFacet));
};

export { ConnectedFacetsContainer };
//# sourceMappingURL=ConnectedFacetsContainer.js.map
